<template>
  <div>
    <NavBar />
    <b-overlay :show="loading" opacity="0.99">
      <div class="container-fluid">
        <v-card>
          <v-card-text>
            <GroupsList
              @created="
                permissions_needs_refresh = true;
                groups_needs_refresh = true;
              "
              @updated="
                permissions_needs_refresh = true;
                groups_needs_refresh = true;
              "
              @refreshed="groups_needs_refresh = false"
              :needs_refresh="groups_needs_refresh"
            />
            <hr />
            <PermissionsList
              @created="
                groups_needs_refresh = true;
                permissions_needs_refresh = true;
              "
              @updated="
                groups_needs_refresh = true;
                permissions_needs_refresh = true;
              "
              @refreshed="permissions_needs_refresh = false"
              :needs_refresh="permissions_needs_refresh"
            />
          </v-card-text>
        </v-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import GroupsList from "../templates/AdminPermissionsManagement/GroupsList";
import PermissionsList from "../templates/AdminPermissionsManagement/PermissionsList";

import { adminData } from "../lib/functions";

export default {
  name: "AdminPermissionsManagement",
  components: {
    NavBar,
    GroupsList,
    PermissionsList,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      groups_needs_refresh: false,
      permissions_needs_refresh: false,

      loading: false,
    };
  },
  created() {
    this.permissions = adminData().permissions;
  },
};
</script>